import { tooltipGiftWidth } from 'components/page/UserProfile/constants'

export const calculatePositionLeft = (
  parent: HTMLElement,
  element: HTMLElement
) => {
  const elementHalfWidth = element.offsetWidth / 2
  const halfTooltipWidth = tooltipGiftWidth / 2
  const point = Math.abs(halfTooltipWidth - elementHalfWidth)
  const positionWithoutScroll = element.offsetLeft - parent.scrollLeft
  const elementPositionLeft = positionWithoutScroll

  const edgeLeft = 0
  const edgeRight = elementPositionLeft + tooltipGiftWidth - elementHalfWidth
  const parentWidth = parent.offsetWidth

  /**
   * Элемент слева за границей, ставим в край левой границы
   */
  if (edgeLeft >= positionWithoutScroll) {
    return halfTooltipWidth
  }

  /**
   * Элемент за границей справа (с погрешностью для некоторых браузеров),
   * ставим в край правой границы
   */
  const inaccuracyGap = 2

  if (edgeRight >= parentWidth - inaccuracyGap) {
    return parentWidth - halfTooltipWidth
  }

  /**
   * Tooltip не хватит места справа, ставим по правой границы текущего блока
   */
  if (parentWidth - elementPositionLeft < point) {
    return elementPositionLeft - (halfTooltipWidth - elementHalfWidth)
  }

  /**
   * Tooltip не хватит места слева, ставим по левой границы текущего блока
   */

  if (elementPositionLeft < point) {
    return elementPositionLeft + halfTooltipWidth
  }

  /**
   * Tooltip места хватит, ставим по центру
   */
  return elementPositionLeft + elementHalfWidth
}
